import { ClosingCTA } from './components/ClosingCTA.tsx';
import { Features } from './components/Features.tsx';
import { Hero } from './components/Hero.tsx';
import { HowItWorks } from './components/HowItWorks.tsx';
import { Pricing } from './components/Pricing.tsx';
import { ProviderRow } from './components/ProviderRow.tsx';
import { PublicLayout } from './components/PublicLayout.tsx';
import { StatusPage } from './components/StatusPage.tsx';
import { Tools } from './components/Tools.tsx';
import { useCatalog } from './hooks/useCatalog.ts';
import { useHashRoute } from './hooks/useHashRoute.ts';
import { useStatus } from './hooks/useStatus.ts';

export function App(): JSX.Element {
  const route = useHashRoute();

  if (route.page === 'pricing') {
    return (
      <PublicLayout>
        <PricingPage />
      </PublicLayout>
    );
  }

  if (route.page === 'status') {
    return (
      <PublicLayout>
        <StatusRoute />
      </PublicLayout>
    );
  }

  return (
    <PublicLayout>
      <LandingPage />
    </PublicLayout>
  );
}

function PricingPage(): JSX.Element {
  const catalog = useCatalog();
  return <Pricing catalogSkus={catalog.skus} fxRate={catalog.fxRate} />;
}

function LandingPage(): JSX.Element {
  const catalog = useCatalog();
  return (
    <>
      <Hero />
      <ProviderRow />
      <Features />
      <Tools />
      <Pricing catalogSkus={catalog.skus} fxRate={catalog.fxRate} />
      <HowItWorks />
      <ClosingCTA />
    </>
  );
}

function StatusRoute(): JSX.Element {
  const status = useStatus();
  return (
    <StatusPage
      data={status.data}
      namespaces={status.namespaces}
      loading={status.loading}
      error={status.error}
    />
  );
}
